import { blocknoteContentToText } from './blocknoteContentToText.js';
export const isBlocknoteContentEmpty = (content) => {
    if (!content) {
        return true;
    }
    if (content.length === 0) {
        return true;
    }
    if (content.some((block) => block.type !== 'paragraph')) {
        return false;
    }
    if (blocknoteContentToText(content).trim() === '') {
        return true;
    }
    return false;
};
//# sourceMappingURL=isBlocknoteContentEmpty.js.map